import { meerpScaffoldEN, meerpScaffoldTH } from "./meerpScaffold";
import { meerpV2EN, meerpV2TH } from "./meerpV2";
import { meerpHandoffEN, meerpHandoffTH } from "./meerpHandoff";
import { meerpPhaseBEN, meerpPhaseBTH } from "./meerpPhaseB";
import { meerpApprovalEN, meerpApprovalTH } from "./meerpApproval";
import { meerpRequestOrderEN, meerpRequestOrderTH } from "./meerpRequestOrder";

export const meerpTH: Record<string, string> = {
  ...meerpScaffoldTH,
  ...meerpV2TH,
  ...meerpHandoffTH,
  ...meerpPhaseBTH,
  ...meerpApprovalTH,
  ...meerpRequestOrderTH,
  ADMIN_MENU_NAME_MeERP: "MeERP",
  MEERP_TITLE: "ระบบจัดซื้อยา บัญชีและการเงิน",
  MEERP_DIVISION: "หน่วยงาน: {name}",
  MEERP_NO_DIVISION: "หน่วยงานที่เลือก",
  MEERP_NAV_COLLAPSE: "ย่อเมนูด้านซ้าย",
  MEERP_NAV_EXPAND: "ขยายเมนูด้านซ้าย",
  MEERP_OVERVIEW: "ภาพรวมงาน",
  MEERP_OVERVIEW_LIVE_NOTE: "ตัวเลขเป็นจำนวนเอกสารตามสถานะจาก PUR แบบอ่านอย่างเดียว ไม่ใช่ยอดเงินหรือข้อมูลบัญชี",
  MEERP_OVERVIEW_COUNT_NOTE: "จำนวนเอกสารจาก PUR",
  MEERP_OVERVIEW_PENDING_MR: "ใบขอซื้อรออนุมัติ",
  MEERP_OVERVIEW_PENDING_PO: "PO รอรับยา",
  MEERP_OVERVIEW_PENDING_GR: "ใบรับยารอตรวจ",
  MEERP_OVERVIEW_PENDING_DOCUMENT: "เอกสารผู้ขายรอตรวจ",
  MEERP_PROCUREMENT: "จัดซื้อยา",
  MEERP_RECEIVING: "รับยาเข้าคลัง",
  MEERP_FINANCE: "บัญชีและการเงิน",
  MEERP_REPORTS: "เอกสารและรายงาน",
  MEERP_OVERVIEW_HINT: "เริ่มจากรายการจัดซื้อและรับยาที่เชื่อมกับ PUR",
  MEERP_PROCUREMENT_HINT: "ดูใบขอซื้อและใบสั่งซื้อพร้อมสถานะจากระบบ PUR",
  MEERP_RECEIVING_HINT: "ดูใบสั่งซื้อที่พร้อมรับและประวัติใบรับยา",
  MEERP_FINANCE_HINT: "รอสัญญา ACC และสูตรที่ธนาคารรับรองก่อนเปิดธุรกรรมการเงิน",
  MEERP_REPORTS_HINT: "รอแบบฟอร์มธนาคารและแหล่งเอกสารที่รับรอง",
  MEERP_READ_ONLY: "ระยะนี้แสดงข้อมูลจาก PUR แบบอ่านอย่างเดียว",
  MEERP_MATERIAL_REQUESTS: "ใบขอซื้อ",
  MEERP_PURCHASE_ORDERS: "ใบสั่งซื้อ",
  MEERP_PENDING_ORDERS: "PO รอรับยา",
  MEERP_RECEIPT_HISTORY: "ประวัติรับยา",
  MEERP_STATUS_FILTER: "สถานะ",
  MEERP_STATUS_ALL: "ทุกสถานะ",
  MEERP_STATUS_DRAFT: "ร่าง",
  MEERP_STATUS_SUBMITTED: "รออนุมัติ",
  MEERP_STATUS_PENDING_APPROVAL: "รออนุมัติ",
  MEERP_STATUS_APPROVED: "อนุมัติ",
  MEERP_STATUS_PARTIALLY_ORDERED: "สั่งซื้อบางส่วน",
  MEERP_STATUS_ORDERED: "สั่งซื้อแล้ว",
  MEERP_STATUS_PARTIALLY_RECEIVED: "รับบางส่วน",
  MEERP_STATUS_COMPLETED: "รับและวางบิลครบ",
  MEERP_STATUS_VERIFIED: "ยืนยันรับ",
  MEERP_STATUS_CANCELLED: "ยกเลิก",
  MEERP_NUMBER: "เลขเอกสาร",
  MEERP_DATE: "วันที่",
  MEERP_STATUS: "สถานะ",
  MEERP_VENDOR: "บริษัท",
  MEERP_PROJECT: "โครงการ",
  MEERP_STORAGE: "คลัง",
  MEERP_TOTAL: "ยอดรวม",
  MEERP_ITEMS: "รายการยา",
  MEERP_PRODUCT: "ยา",
  MEERP_UNIT: "หน่วย",
  MEERP_ORDERED_QUANTITY: "จำนวนสั่ง",
  MEERP_REQUESTED_QUANTITY: "จำนวนขอ",
  MEERP_RECEIVED_QUANTITY: "จำนวนรับ",
  MEERP_UNIT_COST: "ราคาทุน/หน่วย",
  MEERP_BATCH: "Lot",
  MEERP_MANUFACTURED: "วันผลิต",
  MEERP_EXPIRES: "วันหมดอายุ",
  MEERP_PURPOSE: "เหตุผลขอซื้อ",
  MEERP_DETAIL: "รายละเอียด",
  MEERP_OPEN_DETAIL: "เปิดรายละเอียด",
  MEERP_CLOSE_DETAIL: "ปิดรายละเอียด",
  MEERP_REFRESH: "โหลดใหม่",
  MEERP_RETRY: "ลองอีกครั้ง",
  MEERP_PREVIOUS: "ก่อนหน้า",
  MEERP_NEXT: "ถัดไป",
  MEERP_PAGE: "หน้า {current} จาก {total}",
  MEERP_COUNT: "ทั้งหมด {count} รายการ",
  MEERP_LOADING: "กำลังโหลดข้อมูล…",
  MEERP_EMPTY: "ไม่มีรายการในสถานะนี้",
  MEERP_NO_ITEMS: "เอกสารนี้ไม่มีรายการยา",
  MEERP_ITEMS_UNAVAILABLE: "ระบบ PUR ยังไม่ส่งรายละเอียดรายการยา",
  MEERP_UNKNOWN: "—",
  MEERP_ERROR: "โหลดข้อมูล PUR ไม่สำเร็จ กรุณาลองอีกครั้ง",
  MEERP_FORBIDDEN: "บัญชีนี้ไม่มีสิทธิ์ดูข้อมูล PUR ของหน่วยงานที่เลือก",
  MEERP_UNAVAILABLE: "PUR API นี้ยังไม่พร้อมใช้งานในระบบปัจจุบัน",
  MEERP_INVALID_RESPONSE: "รูปแบบข้อมูล PUR ไม่ตรงกับสัญญาที่หน้าจอรองรับ",
};

export const meerpEN: Record<string, string> = {
  ...meerpScaffoldEN,
  ...meerpV2EN,
  ...meerpHandoffEN,
  ...meerpPhaseBEN,
  ...meerpApprovalEN,
  ...meerpRequestOrderEN,
  ADMIN_MENU_NAME_MeERP: "MeERP",
  MEERP_TITLE: "Medicine procurement and finance",
  MEERP_DIVISION: "Division: {name}",
  MEERP_NO_DIVISION: "Selected division",
  MEERP_NAV_COLLAPSE: "Collapse the side menu",
  MEERP_NAV_EXPAND: "Expand the side menu",
  MEERP_OVERVIEW: "Overview",
  MEERP_OVERVIEW_LIVE_NOTE: "Counts are read-only PUR document statuses, not financial totals or accounting data.",
  MEERP_OVERVIEW_COUNT_NOTE: "PUR document count",
  MEERP_OVERVIEW_PENDING_MR: "Material requests awaiting approval",
  MEERP_OVERVIEW_PENDING_PO: "POs awaiting receipt",
  MEERP_OVERVIEW_PENDING_GR: "Receipts awaiting review",
  MEERP_OVERVIEW_PENDING_DOCUMENT: "Vendor documents awaiting review",
  MEERP_PROCUREMENT: "Procurement",
  MEERP_RECEIVING: "Goods receiving",
  MEERP_FINANCE: "Accounting and finance",
  MEERP_REPORTS: "Documents and reports",
  MEERP_OVERVIEW_HINT: "Start with procurement and receiving records from PUR",
  MEERP_PROCUREMENT_HINT: "View material requests and purchase orders with live PUR status",
  MEERP_RECEIVING_HINT: "View purchase orders ready to receive and receipt history",
  MEERP_FINANCE_HINT: "Finance transactions await the ACC contract and bank-approved rules",
  MEERP_REPORTS_HINT: "Bank-approved templates and document sources are pending",
  MEERP_READ_ONLY: "PUR records are read-only in this phase",
  MEERP_MATERIAL_REQUESTS: "Material requests",
  MEERP_PURCHASE_ORDERS: "Purchase orders",
  MEERP_PENDING_ORDERS: "POs awaiting receipt",
  MEERP_RECEIPT_HISTORY: "Receipt history",
  MEERP_STATUS_FILTER: "Status",
  MEERP_STATUS_ALL: "All statuses",
  MEERP_STATUS_DRAFT: "Draft",
  MEERP_STATUS_SUBMITTED: "Submitted",
  MEERP_STATUS_PENDING_APPROVAL: "Pending approval",
  MEERP_STATUS_APPROVED: "Approved",
  MEERP_STATUS_PARTIALLY_ORDERED: "Partially ordered",
  MEERP_STATUS_ORDERED: "Ordered",
  MEERP_STATUS_PARTIALLY_RECEIVED: "Partially received",
  MEERP_STATUS_COMPLETED: "Received and billed",
  MEERP_STATUS_VERIFIED: "Verified",
  MEERP_STATUS_CANCELLED: "Cancelled",
  MEERP_NUMBER: "Document number",
  MEERP_DATE: "Date",
  MEERP_STATUS: "Status",
  MEERP_VENDOR: "Vendor",
  MEERP_PROJECT: "Project",
  MEERP_STORAGE: "Storage",
  MEERP_TOTAL: "Total",
  MEERP_ITEMS: "Medicine lines",
  MEERP_PRODUCT: "Product",
  MEERP_UNIT: "Unit",
  MEERP_ORDERED_QUANTITY: "Ordered",
  MEERP_REQUESTED_QUANTITY: "Requested",
  MEERP_RECEIVED_QUANTITY: "Received",
  MEERP_UNIT_COST: "Unit cost",
  MEERP_BATCH: "Lot",
  MEERP_MANUFACTURED: "Manufactured",
  MEERP_EXPIRES: "Expires",
  MEERP_PURPOSE: "Purpose",
  MEERP_DETAIL: "Details",
  MEERP_OPEN_DETAIL: "Open details",
  MEERP_CLOSE_DETAIL: "Close details",
  MEERP_REFRESH: "Refresh",
  MEERP_RETRY: "Retry",
  MEERP_PREVIOUS: "Previous",
  MEERP_NEXT: "Next",
  MEERP_PAGE: "Page {current} of {total}",
  MEERP_COUNT: "{count} records",
  MEERP_LOADING: "Loading…",
  MEERP_EMPTY: "No records in this status",
  MEERP_NO_ITEMS: "This document has no medicine lines",
  MEERP_ITEMS_UNAVAILABLE: "PUR did not include medicine line details",
  MEERP_UNKNOWN: "—",
  MEERP_ERROR: "Could not load PUR data. Please try again.",
  MEERP_FORBIDDEN: "This account cannot view PUR data for the selected division",
  MEERP_UNAVAILABLE: "This PUR API is not yet available in this environment",
  MEERP_INVALID_RESPONSE: "PUR returned a format this screen does not support",
};
